// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Lu-z","badgeLink":"Mu-z","category":"Nu-z"};